export const CONTACT = {
  phoneDisplay: "+971 50 645 7321",
  phoneRaw: "+971506457321",
  phone2Display: "+91 73000 63398",
  phone2Raw: "+917300063398",
  phone3Display: "+971 56 772 6902",
  phone3Raw: "+971567726902",
  whatsapp: "https://wa.me/971506457321",
  instagram: "https://www.instagram.com/rktousrismandtravel",
  youtube: "https://www.youtube.com/@RkTourismAndTravel",
  facebook: "https://www.facebook.com/share/1JT7X9FQDh/",
  email: "rktraveltourisms@gmail.com",
  location: "Office No. 704, Twin Towers, Al Qusais-3, Dubai, UAE",
  mapEmbed: "https://www.google.com/maps?q=Twin+Towers,+Al+Qusais+3,+Dubai,+UAE&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=Twin+Towers+Al+Qusais+3+Dubai+UAE",
  builder: "Kunaal Parkash Pemani",
};

export const IMAGES = {
  hero: "/hero-dubai.jpg",
};

export const DESTINATIONS = [
  { name: "USA", tagline: "Coast to coast icons", image: "https://images.pexels.com/photos/35566848/pexels-photo-35566848.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-4" },
  { name: "Canada", tagline: "Lakes, peaks & cities", image: "https://images.pexels.com/photos/13111232/pexels-photo-13111232.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "Australia", tagline: "Reefs & outback", image: "https://images.pexels.com/photos/35201640/pexels-photo-35201640.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "New Zealand", tagline: "Middle-earth majesty", image: "https://images.pexels.com/photos/14788649/pexels-photo-14788649.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "Europe", tagline: "Old-world grandeur", image: "https://images.pexels.com/photos/30776070/pexels-photo-30776070.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "China", tagline: "Ancient wonders", image: "https://images.pexels.com/photos/20167101/pexels-photo-20167101.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-3" },
  { name: "Singapore", tagline: "The garden city", image: "https://images.pexels.com/photos/15480459/pexels-photo-15480459.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-3" },
  { name: "Malaysia", tagline: "Towers & tropics", image: "https://images.pexels.com/photos/38320074/pexels-photo-38320074.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "Thailand", tagline: "Temples & islands", image: "https://images.pexels.com/photos/28581877/pexels-photo-28581877.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "Dubai", tagline: "Our home skyline", image: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?auto=compress&cs=tinysrgb&w=1200", span: "lg:col-span-2" },
  { name: "Saudi Arabia", tagline: "Heritage & horizons", image: "https://images.unsplash.com/photo-1711336290921-1fd1eeadd569?q=80&w=1200&auto=format&fit=crop", span: "lg:col-span-4" },
];

export const GALLERY = [
  { image: "/hero-dubai.jpg", caption: "Dubai, United Arab Emirates" },
  { image: "https://images.pexels.com/photos/28581877/pexels-photo-28581877.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "Island cliffs, Thailand" },
  { image: "https://images.pexels.com/photos/30776070/pexels-photo-30776070.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "Old-world grandeur, Europe" },
  { image: "https://images.pexels.com/photos/15480459/pexels-photo-15480459.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "Marina Bay, Singapore" },
  { image: "https://images.pexels.com/photos/14788649/pexels-photo-14788649.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "South Island, New Zealand" },
  { image: "https://images.pexels.com/photos/35566848/pexels-photo-35566848.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "City lights, USA" },
  { image: "https://images.unsplash.com/photo-1711336290921-1fd1eeadd569?q=80&w=900&auto=format&fit=crop", caption: "Desert heritage, Saudi Arabia" },
  { image: "https://images.pexels.com/photos/38320074/pexels-photo-38320074.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "Kuala Lumpur, Malaysia" },
];

export const SERVICES = [
  {
    title: "International Tour Packages",
    desc: "Thoughtfully composed tours across the USA, Canada, Australia, New Zealand, Europe, China, Singapore, Malaysia, Thailand, Dubai and Saudi Arabia — escorted or entirely your own.",
  },
  {
    title: "Visit Visa & Entry Permission",
    desc: "Our UAE-based visa desk handles visit visas and entry permissions with clear guidance, honest timelines and careful document preparation at every step.",
  },
  {
    title: "Flights, Hotels & Transfers",
    desc: "One conversation covers it all — flights, handpicked stays, airport transfers and local transport, booked together so nothing is left to chance.",
  },
  {
    title: "Tailor-Made Itineraries",
    desc: "Honeymoons, family holidays, group adventures or business travel — every route is drawn around your pace, your budget and your idea of a perfect day.",
  },
];

export const PROCESS_STEPS = [
  { title: "Tell Us Your Dream", desc: "A call, a WhatsApp message or the form below — share where you want to go and how you love to travel." },
  { title: "We Design the Route", desc: "Your personal travel designer drafts a day-by-day itinerary with stays, experiences and honest pricing." },
  { title: "Visas & Bookings Handled", desc: "Visit visas, entry permissions, flights and hotels — our desk manages the paperwork while you pack." },
  { title: "Travel With Support", desc: "From departure to return, a real person from our UAE office is one message away, day or night." },
];

export const WHY_US = [
  "UAE-based team you can actually reach — by phone, WhatsApp or in person",
  "Visit visa & entry permission expertise under one roof",
  "Transparent pricing with no hidden extras",
  "Every itinerary built from scratch, never copied from a brochure",
];

export const STATS = [
  { value: 11, suffix: "", label: "Destinations Curated" },
  { value: 100, suffix: "%", label: "Tailor-Made Journeys" },
  { value: 24, suffix: "/7", label: "Traveller Support" },
  { value: 365, suffix: "", label: "Days a Year, At Your Service" },
];

export const REVIEWS = [
  {
    quote: "Our Europe trip was planned down to the hour without ever feeling rushed. The visa paperwork was the part I dreaded most — RK handled it completely.",
    name: "Fatima A.",
    place: "Dubai, UAE",
  },
  {
    quote: "I sent one WhatsApp message and within a day had a full Thailand itinerary with flights and hotels. Everything worked exactly as promised.",
    name: "Rohit S.",
    place: "Abu Dhabi, UAE",
  },
  {
    quote: "They arranged our family's visit visas and a week in Singapore and Malaysia. Clear prices, quick replies, zero stress. We will travel with them again.",
    name: "Elena M.",
    place: "Sharjah, UAE",
  },
];

export const FAQS = [
  {
    q: "Which destinations do you arrange tours to?",
    a: "We design tours across eleven destinations: the USA, Canada, Australia, New Zealand, Europe, China, Singapore, Malaysia, Thailand, Dubai and Saudi Arabia. Every itinerary is tailored — from single-city escapes to multi-country journeys.",
  },
  {
    q: "Do you handle visit visas and entry permissions?",
    a: "Yes. Visit visas and entry permissions are one of our specialties. Our UAE-based visa desk prepares and reviews your documents, advises on requirements for each destination and guides you through the process step by step.",
  },
  {
    q: "How do I start planning my trip?",
    a: "Three easy ways: call us on +971 50 645 7321 (UAE) or +91 73000 63398 (India), message us on WhatsApp, or send the booking request form on this page. Tell us your destination and rough dates, and we will come back with a tailored plan.",
  },
  {
    q: "Can you customise a package around my budget?",
    a: "Absolutely. Nothing we sell is off the shelf. Share your budget, travel style and must-sees, and your travel designer will shape the itinerary around them — with transparent pricing before you commit.",
  },
  {
    q: "Do you also book flights, hotels and transfers?",
    a: "Yes. Flights, hotels, airport transfers and local transport can all be arranged together with your tour, so your whole journey is managed in one place by one team.",
  },
  {
    q: "Where are you located?",
    a: "Our office is at Office No. 704, Twin Towers, Al Qusais-3, Dubai, UAE — you're welcome to visit us in person. We serve travellers across the UAE and beyond, and you can always reach us by phone, WhatsApp or email at rktraveltourisms@gmail.com.",
  },
];
